

    import { Vue, Component, Watch } from "vue-property-decorator";
    import { SchedulingPreferences, DayOfWeekPreferences } from '@/models';
    import SaveMsgPopUp from "@/views/shared/SaveMsgPopUp.vue";
    import { namespace } from "vuex-class";
    const profile = namespace("profile");
    // import { bus } from '../../main'
    import bus from '../../eventBus'
    import TrainingVideos from '../shared/TrainingVideos.vue';

    @Component({
        components: { SaveMsgPopUp,TrainingVideos }
    })
    export default class SchedulingPref extends Vue {
        old_schedulingData!: SchedulingPreferences;

        isModalVisible: boolean = false;
        msgValue: string = '';
        classFlag: string = '';

        is_selfScheduling_Changed: boolean = false;
        //is_marketFloat_Changed: boolean = false;
        is_dowPref_Changed: boolean = false;
        is_shiftPattern_Changed: boolean = false;
        @profile.State
        public schedulingPrefData!: SchedulingPreferences;
        @profile.State
        isAdmin!: boolean;

        @profile.State
        public profileData!: any;

        @profile.State
        isImpersonating!: boolean;

        constructor() {
            super();
            //get singal r notification by using event bus
            bus.$on("smsprefchanged", (msg) => {
                this.getSchedulingPrefData();
                this.$notify({
                    group: "smspreference",
                    title: "Alert",
                    text: msg,
                });
            });
        }
        mounted() {
            this.getSchedulingPrefData();
        }

        async getSchedulingPrefData() {
            await this.$store.dispatch('profile/getSchedulingPrefDetails', this.profileData.username)
                .then((res: any) => {
                    this.old_schedulingData = JSON.parse(JSON.stringify(this.schedulingPrefData));    
                                   
                })
                .catch((err: any) => {
                    if (err) {
                        console.log(err);
                    }
                });
        }

        async saveSchedulingDetails() {                        
             for (var i = 0; i < this.schedulingPrefData.daysOfWeek.length; i++) {
                if(this.schedulingPrefData.daysOfWeek[i].avaliablity == "I prefer to work")
                {
                this.schedulingPrefData.daysOfWeek[i].preference = true
                }
                else
                {
                    this.schedulingPrefData.daysOfWeek[i].preference = false
                }                
            } 
                    this.schedulingPrefData.shiftPattern = Number(this.schedulingPrefData.shiftPattern); 
                    await this.$store.dispatch('profile/saveSchedulingPrefDetails', { username: this.profileData.username, schPrefData: this.schedulingPrefData })                .then((res: any) => {
                    this.is_selfScheduling_Changed = false;
                    //this.is_marketFloat_Changed = false;
                    this.is_dowPref_Changed = false;      
                    this.is_shiftPattern_Changed = false;              
                    this.msgValue = 'Your changes have been saved.';
                    this.classFlag = 'success';
                    this.showModal();
                })
                .catch((err: any) => {
                    if (err) {
                        console.log(err);                        
                    }
                });
        }

        @Watch('schedulingPrefData.selfScheduling')
        onSSChanges(newValue: boolean) {
            if (this.old_schedulingData != undefined) {
                this.is_selfScheduling_Changed = (this.old_schedulingData.selfScheduling !== newValue ? true : false);
            }
        }

        //@Watch('schedulingPrefData.marketFloat')
        //onMFChanges(newValue: boolean) {
        //    if (this.old_schedulingData != undefined) {
        //        this.is_marketFloat_Changed = (this.old_schedulingData.marketFloat !== newValue ? true : false);
        //    }
        //}

        @Watch('schedulingPrefData.shiftPattern')
        onSPChanges(newValue: number) {
           if (this.old_schedulingData != undefined) {
               this.is_shiftPattern_Changed = (this.old_schedulingData.shiftPattern !== newValue ? true : false);
           }
        }

        @Watch('schedulingPrefData.daysOfWeek', { deep: true })
        onDWPChanges(newValue: DayOfWeekPreferences[]) {
            if (this.old_schedulingData != undefined) {
                let isChanged: boolean = false;
                for (var i = 0; i < newValue.length; i++) {
                    isChanged = (this.old_schedulingData.daysOfWeek[i].avaliablity !== newValue[i].avaliablity ? true : isChanged);
                }
                this.is_dowPref_Changed = isChanged;
            }
        }

        get anyChangeHappend() {
            return (this.is_selfScheduling_Changed || this.is_dowPref_Changed || this.is_shiftPattern_Changed); // this.is_marketFloat_Changed ||
        }

        showModal() {
            this.isModalVisible = true;
        }
        closeModal() {
            this.isModalVisible = false;
        }
    }
